import { render, staticRenderFns } from "./TextView.vue?vue&type=template&id=c88cd962&scoped=true&"
import script from "./TextView.vue?vue&type=script&lang=ts&"
export * from "./TextView.vue?vue&type=script&lang=ts&"
import style0 from "./TextView.vue?vue&type=style&index=0&id=c88cd962&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88cd962",
  null
  
)

export default component.exports